import { pesRouterNavigationType } from '@pes-ui/utils';
const map = ['country', 'language', 'page', 'pageId', 'businessId', 'userType'];
export default function parseUrl(navigation, base_dir) {
  const segments = (navigation === pesRouterNavigationType.HASH
    ? window.location.hash.replace('#', '')
    : window.location.pathname)
    .replace(new RegExp('^/'), '');
  const baseDirNoSlash = base_dir.replace(/^\//, '').replace(/\/$/, '');
  if (segments === '' || new RegExp(`^${base_dir}/?$`).test(segments)) {
    return {
      base_dir: baseDirNoSlash,
    };
  }
  const paramMap = segments
    .replace(new RegExp(`^${baseDirNoSlash || ''}/?`), '')
    .replace(/\/$/, '')
    .split('/');
  const routeObj = {
    base_dir: baseDirNoSlash,
    searchParams: {},
  };
  paramMap.forEach((item, index) => {
    if (item && map[index]) {
      routeObj[map[index]] = item;
    }
  });
  new URLSearchParams(window.location.search).forEach((value, key) => {
    routeObj.searchParams[key] = value;
  });
  return routeObj;
}
